import React from "react";
import ReactDOM from "react-dom/client";
import "lenis/dist/lenis.css";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root não encontrado em public/index.html");

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
